import { createRoot } from 'react-dom/client'

import LayoutContainer from '@/components/LayoutContainer'

import App from './App'

import './app/globals.scss'

const root = document.getElementById('root')
if (root) {
  createRoot(root).render(
    <LayoutContainer>
      <App />
      <div id='ew-modal' />
    </LayoutContainer>
  )
}
